import { handleActions } from "redux-actions";
import { SET_LOADING, FETCH_HEATMAP_DATA_SUCCESS } from "./heatmapSaga";

// Name Spaced Action Types
export const actions = {
  SET_LOADING,
  FETCH_HEATMAP_DATA_SUCCESS
};

export const initialState = {
  data: [],
  links: [],
  month: {},
  riders: {},
  filters: null,
  isLoading: true,
  regionalVisitOptions: [
    {
      label: "With Cross Regional Visits",
      value: true
    },
    {
      label: "Without Cross Regional Visits",
      value: false
    }
  ],
  selectedRegionalVisit: {
    label: "With Cross Regional Visits",
    value: true
  },
  numbersOrPercentageOptions: [
    {
      label: "Percentage",
      value: "percentages"
    },
    {
      label: "Number",
      value: "numbers"
    }
  ]
};

export default handleActions(
  {
    [SET_LOADING]: (state, { payload }) => ({
      ...state,
      isLoading: payload || state.isLoading
    }),
    [FETCH_HEATMAP_DATA_SUCCESS]: (
      state,
      { payload: { data, links, months, riders, filters } }
    ) => {
      return {
        ...state,
        data: data || state.data,
        links: links || state.links,
        month: months || state.month,
        riders: riders || state.riders,
        filters: filters || state.filters,
        isLoading: false
      };
    }
  },
  initialState
);
